import React from 'react';

export const getAmenitiesIconUrl = (key) => {
  const obj = {
    "Emergency Contact Number": "https://gos3.ibcdn.com/emergency_contact-1631692867.png",
    "Movie": "https://gos3.ibcdn.com/movies-1631696453.png",
    "Water Bottle": "https://gos3.ibcdn.com/water_bottle-1631696058.png",
    "Blankets": "https://gos3.ibcdn.com/blanket-1631692363.png",
    "Charging Point": "https://gos3.ibcdn.com/charging_point-1631692710.png",
    "Reading Light": "https://gos3.ibcdn.com/readingLight-1631695451.png",
    "NA": "https://gos3.ibcdn.com/default_amenities-1631692790.png",
    "Snacks": "https://gos3.ibcdn.com/snacks-1631695695.png",
    "WIFI": "https://gos3.ibcdn.com/wifi-1631696077.png",
    "CCTV": "https://gos3.ibcdn.com/cctv-1631695920.png",
    "Pillow": "https://gos3.ibcdn.com/pillow-1631695413.png",
    "Toilet": "https://gos3.ibcdn.com/toilet-1631696022.png",
    "Meal": "https://gos3.ibcdn.com/meal-1631695220.png",
    "Personal TV": "https://gos3.ibcdn.com/personal_tv-1631695392.png",
    "Headsets": "https://gos3.ibcdn.com/headset-1631695040.png",
    "Newspaper": "https://gos3.ibcdn.com/newspaper-1631695298.png",
    "Tour Guide": "https://gos3.ibcdn.com/tourguide-1631696097.png",
    "default": "https://gos3.ibcdn.com/default_amenities-1631692790.png",
    "Regular temperature checks": "https://gos3.ibcdn.com/thermometer-1631695988.png",
    "Hand Sanitisers Provided": "https://gos3.ibcdn.com/sanitiser-1631695500.png",
    "Staff with masks": "https://gos3.ibcdn.com/face_mask-1631694792.png",
    "No blankets/linens": "https://gos3.ibcdn.com/no_blanket-1631695321.png",
    "Deep Cleaned Buses": "https://gos3.ibcdn.com/deep_clean-1631692762.png",
    "Bathroom": "https://gos3.ibcdn.com/bathroom-1631692300.png",
    "Heater": "https://gos3.ibcdn.com/heater-1631695061.png",
    "No Amenities": "https://gos3.ibcdn.com/default_amenities-1631692790.png",
    "Satellite": "https://gos3.ibcdn.com/satilite-1631695521.png",
    "Food": "https://gos3.ibcdn.com/food-1631694858.png",
    "Massage chair": "https://gos3.ibcdn.com/massage_chair-1631695172.png",
    "Track My Bus": "https://gos3.ibcdn.com/live_bus-1631695199.png",
    "Facial Tissues": "https://gos3.ibcdn.com/facial_tissue-1631694812.png",
    "Soft drink": "https://gos3.ibcdn.com/soft_drinks-1631695760.png",
    "Emergency exit": "https://gos3.ibcdn.com/emergency_exit-1631694754.png",
    "Fire Extinguisher": "https://gos3.ibcdn.com/fire_extinguisher-1631694838.png",
    "Hammer (to break glass)": "https://gos3.ibcdn.com/hammer-1631694941.png",
    "Bus Hostess": "https://gos3.ibcdn.com/hostess-1631692430.png",
    "Central TV": "https://gos3.ibcdn.com/central_tv_min-1631692681.png",
    "Cup holder": "https://gos3.ibcdn.com/cup_holder-1631692740.png",
    "Music/MP3": "https://gos3.ibcdn.com/music-1631695253.png",
    "Reclining seat": "https://gos3.ibcdn.com/reclining-1631695470.png",
    "Safety belt": "https://gos3.ibcdn.com/seatbelt-1631695652.png",
    "Smoking room": "https://gos3.ibcdn.com/smookingroom-1631695675.png",
    "Wet Napkin": "https://gos3.ibcdn.com/wet_napkin-1631696121.png",
    "AIR  CONDITIONER": "https://gos3.ibcdn.com/air-conditioner-1631692121.png",
    "No blankets": "https://gos3.ibcdn.com/no_blanket-1631695321.png",
    "gps": "https://gos3.ibcdn.com/gps-1631695096.png",
    "soc_dis": "https://gos3.ibcdn.com/social_distance-1631695722.png",
    "go_safe": "https://gos3.ibcdn.com/gosafe-1631694920.png",
    "reddeal": "https://gos3.ibcdn.com/offer_icon-1631695352.png",
    "rating": "https://gos3.ibcdn.com/top_rated-1631696472.png",
    "zct_msg": "https://gos3.ibcdn.com/free_cancellation-1631694878.png",
  };
  return obj[key] || obj["default"];
}

export const canUseDOM = () => {
  return !!(
    (typeof window !== 'undefined' &&
      window.document && window.document.createElement)
  );
}

export const getTypeView = ({ type, content, title = '', url = '' }) => {

  let view = [];
  switch (type) {
    case 'h2':
      view.push(<h2 key={type} dangerouslySetInnerHTML={{ __html: content }}></h2>)
      break;
    case 'text':
      view.push(<p key={type} className="infoTxt">{content}</p>)
      break;
    case 'link':
      view.push(<a key={type} className="infoLink" href={url}>{title}</a>)
      break;
    case 'li':
      const listItems = content.split(",");
      let listItemsView = []
      for (let i in listItems) {
        listItemsView.push(<li key={i + type}>
          {listItems[i]}
        </li>)
      }
      view.push(<ul key={type} className="infoTxt">{listItemsView}</ul>)
      break;
    default:
      break;
  }
  return view;
}

export const getBreadCrumbObj = (breadCrumbObj, canonical_url) => {
  let itemList = [];
  if (breadCrumbObj && breadCrumbObj.length) {
    for (let i in breadCrumbObj) {
      let { title, url } = breadCrumbObj[i];
      let itemListObj = {
        "@type": "ListItem",
        "position": +i + 1,
        "item": {
          "@type": "WebPage",
          "@id": url || canonical_url,
          "name": title,
        }
      }
      itemList.push(itemListObj);
    }
  }
  const obj = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": itemList
  };
  return obj;
}
